export const replaceEvents = (arr) => {
    return { type: 'REPLACE_EVENTS', payload: arr }
};

export const updateEvent = (obj) => {
    return { type: 'UPDATE_EVENT', payload: obj }
};

export const deleteEvent = (obj) => {
	return { type: 'DELETE_EVENTS', payload: obj }
};